  import { parseToNumericOnly, parseNumericToNonZero }     from "../../../utilities/sanitize"

  export const valuesEval = (array) => {

    // --- Eval 1: Full N/A Set --- //
    const numericValues = parseToNumericOnly(array)
    //console.log("[Y AXIS MIN / MAX EVAL 1 - FULL N/A SET]: numeric values avail. for min / max calcs: ", numericValues.length)

    // --- Eval 2: Full Zero Set --- //
    // [NOTE]: why we gate on this as well - if every value is 0 then Math.max and Math.min are both 0, so the assembler would hand chart js { min: 0, max: 0 }
        // all 0's means Math.max and Math.min are both 0, so the assembler hands chart js { min: 0, max: 0 }.
        // Chart js does not expand a min / max (since the values array we would have supplied to the max and min functions 0 to 0
        // meaning the value range is 0, and every pixel position resolves to NaN and NOTHING paints - no bars and no data labels
        // resulting in the Same blank chart as the full N/A set which we are evaluating before immediatly above, just with a different trigger set (i.e. all 0's)
        // specific to dividendYield: this edge case is high probability in a single current specific metric tile - if you choose all no dividend amount companies - i.e. their dividend yield will all be 0!!
    const nonZeroValues = parseNumericToNonZero(array)
    //console.log("[Y AXIS MIN / MAX EVAL 2 - FULL ZERO SET]: non-zero values avail. for min / max calcs: ", nonZeroValues.length)

    // Gated Branch - either evaluation coming back empty means there is no usable range for the assembler to work from
    if (numericValues.length === 0 || nonZeroValues.length === 0) return false

    // Free to Proceed Branch
    return true
  }

  export const evaluateTileFieldForCompanion = (tileField, companionDictionary) => {
    console.log("[SUCCESS - ENTERTING TILE COMPANION EVAL INTERMEDIATE-ORCHESTRATION SERVICE] Evaluating Charted Tile Field: ", tileField)
    // Note: syntax below returns undefined if key (prop) not found on object
      // i.e. object will at least always exists since the dictionary is a constant we have defined not an API call that might not return anything
      // which would therefore cause the object to not exist, so dont have to worry about that syntax error of keying into a non-object
      // so if you dot notation into an object or dynamic key notation into an object, and the prop in either case doesnt exist on the object
      // the result is an 'undefined prop on the object' i.e. both of those syntaxes will return undefined

    console.log("[RESULT]: Companion exists:", companionDictionary[tileField])
    return companionDictionary[tileField]
  }

  export const evaluateFooterCompanionType = (type) => {
    console.log("[SUCCESS - ENTERTING FOOTER COMPANION EVAL INTERMEDIATE-ORCHESTRATION SERVICE] Evaluating Type: ", type)
    // Note: each domain words its footer companion differently, so the type returned here is what main forks on to pick the assembler
    // [NOTE]: right now this effectively does nothing (passes the type straight through) - it is architected as its own S0 eval orchestrator just in case we need to extend it with more robust logic at the eval step later

    console.log("[RESULT]: Footer Companion Type:", type)
    return type
  }